import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import {
  Button,
  CardBody,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import { DEFAULTPRIMARYCOLOR } from "../../../util"
import moment from "moment"
import { DriverModal } from "../../../components/modal/DriverModal"
import ReplenishmentRecueiptsViewMore from "../../../components/Details/replenishrecieptsviewmore"
import { REPLENISHMENT_RECIEPTS } from "../../../GraphQl/queries"
import { useQuery, useLazyQuery } from "@apollo/client"
import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import { RootState } from "../../../store/store"
import { useSelector } from "react-redux"
import { getColorCode } from "../../../colorCodes"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import { toast } from "react-toastify"
import dayjs from "dayjs";

interface ViewCashChequePaymentSummary {
  date_replenished: string
  no_of_transactions: number
  payment_type: "cash" | "cheque" // Assuming it can be either 'cash' or 'cheque'
  reference_number: string
  replenished_by_name: string
  total_amount: number
  staff_number: string
  payee_name: string
  payee_code: string
}
type replenishType = {
  date_replenished: string
  number_of_trasactions: number
  amount: number
  reference: string
  replenished_by: string
}

const ReplenishmentsReciepts = () => {
  const [handleRow, setHandleRow] = useState<{
    id: string
    type: string
    name: string
    staff: string
    payee_name: string
    payee_code: string
  }>()
  const [open, setOpen] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [Loading, setLoading] = useState(false)

  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const { companyId, user: stateUser } = useSelector(
    (state: RootState) => state.auth
  )

  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setStartDate(formattedValue)
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setEndDate(formattedValue)
  }

  const handleTempStartDateChange = (event:any) => {
    const value = event.target.value
    if(value){
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event:any) => {
    const value = event.target.value
    if(value){
      const formattedValue = value 
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);
  
    if (diffInMonths > 3) {
      toast.error("Date range cannot exceed 3 months.");
      return;
    }
  
    setIsFilterLoading(true);
  
    setTimeout(() => {
      fetchData({
        variables: {
          id: companyId,
          start_date: tempStartDate,
          end_date: tempEndDate
        }
      });
      setIsFilterLoading(false);
    }, 1000);
  };

  const reset =() =>{
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    fetchData({
      variables: {
        id: companyId,
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }

  const [fetchData, { loading, data: replenishment_reciepts }] = useLazyQuery<{
    view_cash_cheque_payment_summary: ViewCashChequePaymentSummary[]
  }>(REPLENISHMENT_RECIEPTS, {
    variables: {
      id: companyId,
    },
  })

  useEffect(() => {
    fetchData({
      variables: {
        id: companyId,
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }, [companyId]);

  const handleSearch = (e: any) => {
    setSearchText(e.target.value)
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser])

  const filterData = (filter: ViewCashChequePaymentSummary) => {
    const date = moment(filter?.date_replenished).format("LL")
    const isTextMatch =
      filter?.total_amount
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.date_replenished
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.no_of_transactions
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.payment_type
        .toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      date?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.payee_name
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.reference_number
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.replenished_by_name
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase())
    return isTextMatch
  }

  useEffect(() => {
    if (searchText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, startDate, endDate, itemsPerPage])

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const totalNum =
    replenishment_reciepts?.view_cash_cheque_payment_summary?.length

  // console.log(replenishment_reciepts?.view_cash_cheque_payment_summary)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  const filteredPolicies = replenishment_reciepts?.view_cash_cheque_payment_summary?.filter(filterData)
  const totalItems = filteredPolicies

  // const totalItems = replenishment_reciepts?.view_cash_cheque_payment_summary
  //   ?.filter(filterData)
  //   ?.filter((item: any) => {
  //     const normalizeDate = (date: Date | string): Date => {
  //       const normalizedDate = new Date(date)
  //       normalizedDate.setHours(0, 0, 0, 0) // Set time to midnight to include the entire day
  //       return normalizedDate
  //     }
  //     const from =
  //       (startDate as any) instanceof Date
  //         ? normalizeDate(startDate)
  //         : normalizeDate(startDate)
  //     const to =
  //       (endDate as any) instanceof Date
  //         ? normalizeDate(endDate)
  //         : normalizeDate(endDate)
  //     const dateCreated = normalizeDate(item.date_replenished)

  //     if (startDate && endDate) {
  //       return dateCreated >= from && dateCreated <= to // Corrected to <= for endDate
  //     } else if (startDate) {
  //       return dateCreated >= from // Only from date is set
  //     } else if (endDate) {
  //       return dateCreated <= to // Only to date is set
  //     }
  //     return true // No filter applied
  //   })

  // const paginatedData = totalItems?.slice(startIndex, endIndex)
  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)

  const handleDownload = () => {
    // Check if there is data to download
    if (paginatedData?.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter
    if (searchText || startDate || endDate) {
      const type = paginatedData?.map((item: ViewCashChequePaymentSummary) => ({
        "reference number": item?.reference_number,
        "no of transactions": item?.no_of_transactions,
        "total amount": item?.total_amount,
        "payment type": item?.payment_type,
        "date replenished": moment(item?.date_replenished).format("YYYY-MM-DD"),
        "time replenished":  moment(item?.date_replenished).format("hh:mm A"),
        "replenished by name": item?.replenished_by_name,
      }))
      const firstItem = type![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })           
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"list-of-all-receipts"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return
    }

    const type = totalItems?.map((item: ViewCashChequePaymentSummary) => ({
      "reference number": item?.reference_number,
      "no of transactions": item?.no_of_transactions,
      "total amount": item?.total_amount,
      "payment type": item?.payment_type,
      "date replenished": moment(item?.date_replenished).format("YYYY-MM-DD"),
      "time replenished":  moment(item?.date_replenished).format("hh:mm A"),
      "replenished by name": item?.replenished_by_name,
    }))
    const firstItem = type![0]
    const originalHeaders = Object.keys(firstItem!)
    const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
    // Transform data to match headers (Simplified)
    const transformedData = type?.map((item) => {
      const transformedItem: Record<string, string> = {};
      originalHeaders.forEach((originalKey, idx) => {
        const upperKey = upperHeaders[idx];
        transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
      });
      return transformedItem;
    });
    // Convert data to CSV format
    const csvData = Papa.unparse({
      fields: upperHeaders,
      data: transformedData!,
    })
    // Create a Blob and download link
    const blob = new Blob([csvData], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    // Create a download link
    const a = document.createElement("a")
    a.href = url
    a.download = `${"list-of-all-receipts"}.csv`
    document.body.appendChild(a)
    // Trigger a click on the link to start the download
    a.click()
    // Cleanup
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }

  return (
    <>
      <CustomHeader title="Receipts" />
      <DriverModal
        title="REPLENISHMENT RECEIPT"
        open={open}
        size={"lg"}
        onClose={() => setOpen(false)}
        children={<ReplenishmentRecueiptsViewMore content={handleRow} />}
      />
      <div className="mt-10 w-full ">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold leading-none opacity-70"
            >
              List of All Reciepts{" "}
              {totalNum && (
                <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                  {totalItems?.length}
                </span>
              )}
            </Typography>
          </div>
          <div className="w-full overflow-auto">
            <div className="flex flex-col gap-2  bg-white p-3">
              <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row pl-10">
                <Tooltip content="Export as CSV">
                  <Button
                    onClick={handleDownload}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2"
                    size="sm"
                  >
                    <FiDownloadCloud size={20} />
                    <span>Download csv</span>
                  </Button>
                </Tooltip>
              </div>
              <div className="p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
                <div className=" mr-3 flex  gap-x-3 w-full">
                  <Input
                    crossOrigin="anonymous"
                    label="Search"
                    placeholder=""
                    value={searchText}
                    onChange={handleSearch}
                    icon={<i className="fas fa-search text-base"></i>}
                  />
                </div>

                <div className="flex flex-col md:flex-row gap-3 justify-between mb-0">
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">From</label>
                    <Input
                      type="datetime-local"
                      value={tempStartDate} // Remove 'Z' for input value
                      onChange={handleTempStartDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">To</label>
                    <Input
                      type="datetime-local"
                      value={tempEndDate} // Remove 'Z' for input value
                      onChange={handleTempEndDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Apply date filters">
                      <Button
                        onClick={handleDateChange}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>Filter</span>
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Clear All Date filters">
                      <Button
                        onClick={reset}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>Clear</span>
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full bg-white table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr className="">
                    {[
                      "Reference",
                      "Number of Transaction",
                      "Amount",
                      "Payment Type",
                      "Date Replenished",
                      "Staff/Intermidiary",
                      "Replenished By",
                      "Action",
                      "",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-2 py-4  "
                      >
                        <Typography
                          color="black"
                          className="font-bold text-[0.8rem] text-black leading-none opacity-70 "
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "px-2 py-3  text-center"
                      : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <>
                        <tr
                          onClick={(e) => {
                            // setSelectedRow(item?.driver_id)
                            e.stopPropagation()
                            // setOpenSideNav(true)
                          }}
                          key={index}
                          className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                        >
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.reference_number}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.no_of_transactions}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {Number.isNaN(item?.total_amount)
                                ? "0.00"
                                : (item?.total_amount).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.payment_type}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {moment(item?.date_replenished).format("LLL")}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.payee_name}
                            </Typography>
                          </td>
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.replenished_by_name}
                            </Typography>
                          </td>

                          <td
                            className={classes}
                            onClick={(e) => {
                              e.stopPropagation()
                            }}
                          >
                            <Button
                              // onClick={() => }
                              onClick={() => {
                                setOpen(true)
                                setHandleRow({
                                  id: item?.reference_number,
                                  staff: item?.staff_number,
                                  type: item?.payment_type,
                                  name: item?.replenished_by_name,
                                  payee_name: item?.payee_name,
                                  payee_code: item?.payee_code,
                                })
                              }}
                              variant="filled"
                              color="green"
                              className="font-normal text-xs w-20 py-1 capitalize"
                            >
                              View More
                            </Button>
                          </td>
                        </tr>
                      </>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(loading || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {paginatedData?.length! === 0 && !loading && !isFilterLoading &&(
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {/* {paginatedData && paginatedData?.length !== 0 && !loading && (
          <GeneralPagination
            totalItems={totalItems?.length!}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )} */}

        {paginatedData && paginatedData?.length !== 0 && !loading && !isFilterLoading &&(
          <PerPageAndPagination
          customColor="white"
            total={totalItems?.length!}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}
      </div>
    </>
  )
}

export default ReplenishmentsReciepts
